<template>
    <div class="user-portfolio-socials">
        <div class="user-portfolio-socials__title">
            Социальные сети
        </div>
        <div v-if="availableIcons.length" class="user-portfolio-socials__icons">
            <template v-for="(item, index) in availableIcons">
                <a
                    v-if="getUser[item.prop]"
                    :key="index"
                    :href="getUser[item.prop]"
                    target="_blank"
                    class="user-portfolio-socials__icon"
                    :class="{
                        [`user-portfolio-socials__icon--${item.icon}`]: true,
                    }"
                ></a>
                <span
                    v-else
                    :key="index"
                    class="user-portfolio-socials__icon"
                    :class="{
                        [`user-portfolio-socials__icon--${item.icon}-gray`]: true,
                        [`user-portfolio-socials__icon--empty`]: true,
                    }"
                    title="Нет данных"
                ></span>
            </template>
        </div>
        <div v-else class="user-portfolio-socials__empty">
            Не указано
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters('newUsers', [
            'getUser',
        ]),
        availableIcons() {
            return this.icons.filter(item => this.getUser[item.prop]);
        },
    },
    data: () => ({
        icons: [
            { icon: 'telegram', prop: 'telegram' },
            { icon: 'vk', prop: 'vk' },
            { icon: 'ok', prop: 'ok' },
            { icon: 'zen', prop: 'zen' },
            { icon: 'yt', prop: 'yt' },
            { icon: 'rutube', prop: 'rutube' },
            { icon: 'tiktok', prop: 'tiktok' },
            { icon: 'yappy', prop: 'yappy' },
            { icon: 'tenchat', prop: 'tenchat' },
        ],
    }),
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-socials {
    &__title {
        font-style: normal;
        font-weight: 700;
        font-size: mrem(18);
        line-height: mrem(24);
        margin-bottom: mrem(16);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
            margin-bottom: rem(16);
        }
    }

    &__icons {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: mrem(20);

        @include on-desktop {
            gap: rem(20);
        }
    }

    &__empty {
        color: $color-main-grey;
        font-weight: 500;
    }

    &__icon {
        display: block;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        order: 0;
        width: mrem(32);
        height: mrem(32);
        border-radius: 100%;

        @include on-desktop {
            width: rem(32);
            height: rem(32);
        }

        &--empty {
            order: 1;
        }

        &--vk {
            background-image: url('~@/assets/images/social/color/vk.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/vk.svg');
            }
        }

        &--ok {
            background-image: url('~@/assets/images/social/color/ok.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/ok.svg');
            }
        }

        &--ig {
            background-image: url('~@/assets/images/social/color/ig.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/ig.svg');
            }
        }

        &--fb {
            background-image: url('~@/assets/images/social/color/fb.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/fb.svg');
            }
        }

        &--yt {
            background-image: url('~@/assets/images/social/color/yt.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/yt.svg');
            }
        }

        &--tiktok {
            background-image: url('~@/assets/images/social/color/tiktok.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/tiktok.svg');
            }
        }

        &--zen {
            background-image: url('~@/assets/images/social/color/dzen.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/dzen.svg');
            }
        }

        &--telegram {
            background-image: url('~@/assets/images/social/color/telegram.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/telegram.svg');
            }
        }

        &--rutube {
            background-image: url('~@/assets/images/social/color/rutube.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/rutube.svg');
            }
        }

        &--yappy {
            background-image: url('~@/assets/images/social/color/yappy.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/yappy.svg');
            }
        }

        &--tenchat {
            background-image: url('~@/assets/images/social/color/tenchat.svg');
            &-gray {
                background-image: url('~@/assets/images/social/gray/tenchat.svg');
            }
        }
    }
}

</style>
